export default __webpack_public_path__ + "static/media/fitness-tracker.f349264b.gif";